module.exports = __webpack_public_path__ + "img/0001.e5ecf9a3.jpg";